import {
  Button,
  Grid,
  Paper,
  TextField,
  Autocomplete,
  TableCell,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableSortLabel,
  TableBody,
} from "@mui/material";
import { observer } from "mobx-react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import Pagination from "base/ui/components/Pagination/pagination";
import React from "react";
import { data } from "./mock";
import { Link, useNavigate } from "react-router-dom";

const createCatalogType = () => {
  // mockup data
  const mock = [
    { key: "1", value: "a" },
    { key: "2", value: "b" },
    { key: "3", value: "c" },
    { key: "4", value: "d" },
    { key: "5", value: "e" },
  ];

  // Custom style của form tìm kiếm
  const Style = {
    ".MuiOutlinedInput-root": {
      padding: 0,
      width: "100%",
      minWidth: "362px",
      borderRadius: "2px",
    },
    "MuiInputBase-multiline": {
      padding: 0,
    },
    "MuiInputBase-root": {
      padding: 0,
    },
    "MuiTextField-root": {
      padding: 0,
    },
    ".MuiOutlinedInput-input": {
      fontSize: "13px",
    },
    "MuiInputBase-root-MuiOutlinedInput-root": {
      padding: 0,
    },
    ".MuiOutlinedInput-notchedOutline": { borderRadius: 0 },
  };

  const StyleTb = {
    MuiTableCellRoot: {
      fontSize: "13px",
      fontWeight: 700,
      padding: "5px 10px",
      lineHeight: "20px",
      color: "white",
    },
    borderInherit: {
      borderCollapse: "inherit",
    },
    MuiButtonBaseRoot: {
      color: "white !important",
    },
    MuiTableCellRootTd: {
      fontSize: "13px",
      padding: "5px",
      lineHeight: "20px",
      borderBottom: "unset",
    },
    sticky1: {
      position: "sticky",
      left: 0,
      background: "white",
      zIndex: 5,
    },
    sticky2: {
      position: "sticky",
      left: 45.2,
      background: "white",
      zIndex: 5,
    },
    sticky3: {
      position: "sticky",
      left: 294.5,
      background: "white",
      zIndex: 5,
      color: "#0284c7",
    },

    ".MuiOutlinedInput-root": {
      padding: 0,
    },
    ".MuiOutlinedInput-input": {
      fontSize: "13px",
    },
    ".MuiOutlinedInput-notchedOutline": { borderRadius: 0 },
  };

  // column render table
  const column = [
    {
      columnName: "STT",
      align: "text-center",
      visible: true,
      sticky: "sticky left-0 bg-primary z-10",
      key: "stt",
    },
    {
      columnName: "Loại danh mục",
      align: "text-center",
      visible: true,
      sticky: "sticky left-[45.2px] min-w-[250.11px]  bg-primary z-10",
    },

    {
      columnName: "Tên loại danh mục",
      align: "text-center",
      visible: true,
    },

    {
      columnName: "Trạng thái",
      align: "text-center",
      visible: true,
      sticky: "sticky left-[294.5px] bg-primary z-10",
      width: "min-w-[120px]",
      isSoft: true,
      key: "workOrderCode",
    },
  ];

  return observer(() => {
    const navigate = useNavigate();
    return (
      <>
        <Grid
          container
          justifyContent={"space-between"}
          paddingX={2}
          paddingTop={2}
        >
          <h2 className="uppercase font-semibold tracking-wide text-gray-800">
            Loại danh mục
          </h2>
          <Link
            to={"Create"}
            target="_blank"
            className="!text-white !bg-blue-600 p-2 rounded"
          >
            <AddCircleOutlineIcon className="mr-2" /> Thêm mới
          </Link>
        </Grid>
        <Paper className="mx-4 my-2">
          <Grid container justifyContent={"space-around"} padding={2}>
            <Grid item>
              <div className="mb-3">
                <label className="mr-5 font-bold text-gray-700 text-sm tracking-wide  ">
                  Loại danh mục
                </label>
                <TextField
                  inputProps={{
                    style: {
                      padding: 6,
                      minWidth: 350,
                      position: "relative",
                    },
                  }}
                  className="[&>div]:!rounded-none"
                />
              </div>
              <div className="flex justify-between">
                <label className="mr-5 font-bold text-gray-700 text-sm tracking-wide">
                  Trạng thái
                </label>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={mock}
                  sx={Style}
                  getOptionLabel={(option) => option.value}
                  renderInput={(params) => <TextField {...params} />}
                  clearIcon={null}
                  disableClearable // disable close button but value not be undefined
                  // onKeyDown khi nhấn nút Backspace không cho xóa
                  onKeyDown={(event: any) => {
                    if (event.key === "Backspace") {
                      event.preventDefault();
                    }
                  }}
                  //Không cho nhập
                  onKeyPress={(e) => {
                    e.preventDefault();
                  }}
                />
              </div>
            </Grid>
            <Grid item>
              <label className="mr-5 font-bold text-gray-700 text-sm tracking-wide">
                Tên loại danh mục
              </label>
              <TextField
                inputProps={{
                  style: {
                    padding: 6,
                    minWidth: 350,
                    position: "relative",
                    borderRadius: "2px !important",
                  },
                }}
                className="[&>div]:!rounded-none"
              />
            </Grid>
          </Grid>
          <Grid container justifyContent={"center"} padding={1}>
            <Button className="!text-white !bg-blue-600">
              <SearchIcon />
              Tìm kiếm
            </Button>
          </Grid>
        </Paper>
        <Grid item container justifyContent={"center"} alignItems={"center"}>
          <Paper
            elevation={3}
            className="shadow-sm shadow-stone-400 p-4 flex-1 overflow-x-auto mx-4 "
          >
            <Pagination
              pageCount={10}
              forcePage={1 - 1}
              onPageSizeChange={() => {
                console.log("handleChangePageSize");
              }}
              onPageChange={() => {
                console.log("handleChangePageIndex");
              }}
            />
            <TableContainer
              component={Paper}
              className="w-full table-auto space-collapse mb-5 mt-5 text-default !overflow-y-auto !max-h-[500px] flex justify-center"
            >
              <Table>
                <TableHead className="font-medium text-gray-700 text-default bg-gray-100 !z-10 !sticky !top-0 flex-1">
                  <TableRow>
                    {column?.map((item, index) => {
                      if (item.visible) {
                        return (
                          <TableCell
                            sx={[StyleTb.MuiTableCellRoot]}
                            key={index}
                            align={`${
                              item.align === "text-center"
                                ? "center"
                                : "inherit"
                            }`}
                            // onClick={
                            //   item.key === 'parentWorkOrderCode' ||
                            //   item.key === 'workOrderCode' ||
                            //   item.key === 'quantity'
                            //     ? () => {
                            //         handleSortRequest(item.key);
                            //       }
                            //     : () => {}
                            // }
                            scope="col"
                            className={`${item.visible ? "" : "hidden"}
                          ${item.sticky} ${item.width}
                           py-2 px-2 border text-left bg-primary ${item.align}`}
                          >
                            {item.key === "parentWorkOrderCode" ||
                            item.key === "workOrderCode" ||
                            item.key === "quantity" ? (
                              <>
                                <TableSortLabel
                                  sx={StyleTb.MuiButtonBaseRoot}
                                  active={true}
                                  classes={{ icon: "!text-white" }}
                                >
                                  {item.columnName}
                                </TableSortLabel>
                              </>
                            ) : (
                              `${item.columnName}`
                            )}
                          </TableCell>
                        );
                      }
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.length ? (
                    data?.map((row, index) => (
                      <TableRow key={row.stt} className="hover:!bg-slate-200">
                        {/* Số thứ tự */}
                        <TableCell
                          align="center"
                          sx={[StyleTb.MuiTableCellRootTd]}
                          className="border"
                        >
                          {row.stt}
                        </TableCell>
                        {/* Mã nhập phiếu */}
                        <TableCell
                          align="center"
                          sx={[StyleTb.MuiTableCellRootTd]}
                          className="border"
                        >
                          <Link
                            to={`Detail/${row.stt}`}
                            target="_blank"
                            className="text-blue-600 hover:opacity-80"
                          >
                            {row.mnp}
                          </Link>
                        </TableCell>
                        {/* Công ty */}
                        <TableCell
                          align="center"
                          sx={[StyleTb.MuiTableCellRootTd]}
                          className="border"
                        >
                          {row.company}
                        </TableCell>
                        {/* Công ty */}
                        <TableCell
                          align="center"
                          sx={[StyleTb.MuiTableCellRootTd]}
                          className="border"
                        >
                          {row.catalog}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={100}
                        sx={[StyleTb.MuiTableCellRootTd]}
                        align="center"
                        className="border whitespace-nowrap"
                      >
                        Không tìm thấy dòng nào phù hợp khong
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <span className="block text-default">
              Đang xem {`100`} trong tổng số {`100`} mục
            </span>
          </Paper>
        </Grid>
      </>
    );
  });
};

export default createCatalogType;
